module.exports = __webpack_public_path__ + "img/logo_thumb.4d6d942e.png";